if (!BEditor.MultiEditor)
{
  BEditor.MultiEditor = MultiEditor;
}


export default function MultiEditor (pParent, editorId, mainEditorIndex, idIn, idOut, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, autoFocus, minEditorHeight, mainIdForBodyStyles, mainClassForBodyStyles, extParameters)
{
  const pThis = this,
        typeName = 'MultiEditor';

  pThis.toString = function () { return typeName; };

  pThis.EditorCreated = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorCreated' });
  pThis.EditorStarted = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorStarted' });
  pThis.EditorStopped = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorStopped' });
  pThis.EditorResized = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorResized' });
  pThis.EditorClicked = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorClicked' });
  pThis.EditorBlured = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorBlured' });
  pThis.EditorFocus = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorFocus' });
  pThis.EditorBlur = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorBlur' });
  pThis.EditorReady = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorReady' });
  pThis.EditorDataChanged = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorDataChanged' });

  pThis.isObjExist = true;
  pThis.isObjValid = false;
  pThis.isObjStay = false;

  pThis.singleEditor = {};
  pThis.editorList = [];
  pThis.editorHash = {};
  pThis.holderHash = {};
  pThis.multiEditorMode = false;
  pThis.editorsCounter = 0;

  pThis.setData = setData;
  pThis.methodsSwitcher = methodsSwitcher;
  pThis.changePageLayout = changePageLayout;
  pThis.changeTypography = changeTypography;
  pThis.changeStyle = changeStyle;
  pThis.getContentStyles = getContentStyles;
  pThis.getIsBlankTemplate = function () { return !pThis.multiEditorMode; };
  pThis.getTemplateCode = function () { return templateCode; };
  pThis.getLayoutId = function () { return layoutId; };
  pThis.getHolderName = function (editorId) { return (pThis.multiEditorMode ? pThis.editorHash[editorId].holderName : null); };
  pThis.freezeHolderFocus = freezeHolderFocus;
  pThis.unfreezeHolderFocus = unfreezeHolderFocus;
  pThis.restoreAttributeForDragDrop = restoreAttributeForDragDrop;
  pThis.mouseMultiDragDrop = mouseMultiDragDrop;
  pThis.getMultiAnchorsList = getMultiAnchorsList;
  pThis.setMultiAnchorsVisibility = setMultiAnchorsVisibility;
  pThis.unloadedEditor = unloadedEditor;
  pThis.getEditorMainContainer = getEditorMainContainer;
  pThis.undoChanges = undoChanges;

  pThis.getEditTimeCounter = getEditTimeCounter; //TODO:Dime TimeEmailCounter

  var i, k;
  var topWin = BEditor.environment.topWindow;
  var $window, $document, $body, $, $$;
  var inContainer;
  var parentContainer;
  var pageLayoutMainContainer;
  var isHideWhenEmpty;
  var checkEditorsStateTM = null;
  var waitScore;
  var htmlContainer = document.createElement('DIV');
  var templateCode,
      layoutId,
      contentHash = null,
      contentHashPointers = null;
  var isHolderFocusFrozen = false,
      isEditorShadingON = false,
      isMockShadingON = false,
      isChangeEditorInstance = false,
      changeEditorInstanceTM;
  var typographyCSSClasses,
      styleCSSClasses,
      contentStyles = {};
  var previousFocusedEditor = {};
  previousFocusedEditor.editorId = null;

  previousFocusedEditor.editor = null;
  var currentFocusedEditor = {};
  currentFocusedEditor.editorId = null;
  currentFocusedEditor.editor = null;

  // TODO: Consider to rename "isTrueEmail"
  var isTrueEmail = !!extParameters.isTrueEmail,
      emailEditorMock,
      targetWindow = extParameters.targetWindow || topWin.contentarea || window;

  var overMethods =
  {
    'reInitEditor': reInitEditorStart,
    'getData': getData,
    'getTextData': getTextData,
    'getHtmlDataLength': getHtmlDataLength,
    'saveData': saveData,
    'unload': unloadEditor
  };

  pThis.copyTextStyle =
  {
    currentStyle: null
  };

  var editTimeCounterInterval = 30000,
      editTimeCounter = 0,
      editTimeStart,
      editTimeStop,
      changeLayoutTimeCounter = 0,
      isStartEmailTimeCounter = false,
      saveContentForEmailTimeCounter = '',
      checkChangeContentForEmailTimeCounterTM = null;  //TODO:Dime EmailTimeCounter

  initEnvironment();
  initMultiEditor();


  function initMultiEditor()
  {
    createEmailEditorMock();
    createEditors();
  }


  function createEmailEditorMock()
  {
    if (!isTrueEmail)
    {
      if (!emailEditorMock)
      {
        isMockShadingON = true;
        BEditor.EditorsManager.showPageShadingContainer(true, null, null, true);
        emailEditorMock = new BEditor.Admin.Emails.EmailEditorMock({ parentComponent: BEditor.AdminPanel, editor: pThis });
        emailEditorMock.ComponentReady.addHandler(onEmailEditorMockReady);
      }
      else if (emailEditorMock && emailEditorMock.isEditorDisposed())
      {
        emailEditorMock.reInit();
      }
    }
  }


  function onEmailEditorMockReady()
  {
    isMockShadingON = false;
    editorShadingOFF();
  }


  function undoChanges()
  {
    //todo Dime realize undo
  }


  function initEnvironment()
  {
    $window = targetWindow;
    $document = $window.document;
    $body = $document.body;
    $ = function(id) { return $document.getElementById(id); };
  }


  function doNotCreateEditors()
  {
  }


  function getEditorMainContainer()
  {
    return inContainer;
  }


  function createEditors()
  {
    var i = 0,
        n,
        templateCodeContainer,
        newInContainer,
        newStyles,
        holders,
        inLayoutContainer = null,
        holderName,
        editMinHeight,
        realMinEditorHeight,
        realAutoFocus,
        button = pToolbar.getButtonByName('FormattingDropdownEmail'),
        editorHolderHoverBorderUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAIAAAD91JpzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjlCREE3QzE5MzY5MTFFNTkyMkFFRjNDNkI4Q0UyNjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjlCREE3QzI5MzY5MTFFNTkyMkFFRjNDNkI4Q0UyNjAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyOUJEQTdCRjkzNjkxMUU1OTIyQUVGM0M2QjhDRTI2MCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyOUJEQTdDMDkzNjkxMUU1OTIyQUVGM0M2QjhDRTI2MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pi8byW8AAAATSURBVHjaYvyYxgAETAxgABBgABEvAVtnO8lIAAAAAElFTkSuQmCC';

    editorShadingON();


    inContainer = $(idIn);
    if (inContainer)
    {
      if (inContainer.nodeName === 'TEXTAREA')
      {
        idIn += '_New';
        newInContainer = $document.createElement('DIV');
        newInContainer.id = idIn;
        newInContainer.style.width = inContainer.offsetWidth + 'px';
        newInContainer.style.height = 'auto';
        newInContainer.innerHTML = (isTrueEmail ? inContainer.value : emailEditorMock.clearStyles(inContainer.value));
        inContainer.parentNode.replaceChild(newInContainer, inContainer);
        inContainer = newInContainer;
      }
      else if (!isTrueEmail)
      {
        inContainer.innerHTML = emailEditorMock.clearStyles(inContainer.innerHTML);
      }

      parentContainer = inContainer.parentNode;

      templateCodeContainer = inContainer.querySelector('[templatecode]');
      templateCode = (templateCodeContainer ? templateCodeContainer.getAttribute('templatecode') : null);

      pageLayoutMainContainer = inContainer.querySelector('[data-layoutid]');
      layoutId = (pageLayoutMainContainer ? pageLayoutMainContainer.getAttribute('data-layoutid') : null);

      waitScore = 373 + BEditor.EditorsManager.setWaitScore(inContainer);
      extParameters.waitScore = waitScore;

      pThis.editorsCounter = 0;

      if (pageLayoutMainContainer && layoutId && inContainer.innerHTML.indexOf('data-cellinner') != -1 && (inContainer.innerHTML.indexOf('data-innereditablearea') != -1 || inContainer.innerHTML.indexOf('data-editablearea') != -1))
      {
        pThis.multiEditorMode = true;
        minEditorHeight = 50;
        holders = inContainer.querySelectorAll('[data-cellinner]');

        for (i = 0; i < holders.length; i++)
        {
          inLayoutContainer = holders[i].querySelector('[data-innereditablearea]');

          if (!inLayoutContainer)
          {
            inLayoutContainer = holders[i].querySelector('[data-editablearea]');

            if (inLayoutContainer)
            {
              inLayoutContainer.setAttribute('data-innereditablearea', inLayoutContainer.getAttribute('data-editablearea'));
              inLayoutContainer.removeAttribute('data-editablearea');
            }
            else
            {
              continue;
            }
          }

          holderName = inLayoutContainer.getAttribute('data-innereditablearea');

          if (inLayoutContainer.id == null || inLayoutContainer.id === '')
          {
            inLayoutContainer.id = 'idEditableArea_' + (new Date()).getTime() + '_' + holderName;
          }

          isHideWhenEmpty = (inLayoutContainer.getAttribute('hideWhenEmpty') && inLayoutContainer.getAttribute('hideWhenEmpty', 0).toLowerCase() == 'true');
          editMinHeight = inLayoutContainer.getAttribute('data-editMinHeight');
          realMinEditorHeight = (editMinHeight != null && editMinHeight !== '' && !isNaN(parseInt(editMinHeight)) ? parseInt(editMinHeight) : minEditorHeight);
          realAutoFocus = false;

          if (pThis.editorList[i])
          {
            pThis.editorList[i].editor.reInitEditor(pThis.editorList[i].id, inLayoutContainer.id, null, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, realAutoFocus, realMinEditorHeight, idIn, mainClassForBodyStyles, extParameters);
          }
          else
          {
            pThis.editorList[i] = {};
            pThis.editorList[i].id = editorId + '__' + i;
            pThis.editorList[i].type = 'Multi';
            pThis.editorList[i].editor = new BEditor.Editor(pThis, pThis.editorList[i].id, inLayoutContainer.id, null, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, realAutoFocus, realMinEditorHeight, idIn, mainClassForBodyStyles, extParameters);
          }

          pThis.editorList[i].hideWhenEmpty = isHideWhenEmpty;
          pThis.editorList[i].contentIFrameName = pThis.editorList[i].editor.editorContentIFrameName;
          pThis.editorList[i].holderName = holderName;
          pThis.editorHash[pThis.editorList[i].id] = pThis.editorList[i];
          pThis.holderHash[pThis.editorList[i].holderName] = pThis.editorList[i];

          pThis.editorList[i].holder = holders[i];
          pThis.editorList[i].outerHolder = getOuterHolder(pThis.editorList[i].holder);
          pThis.editorList[i].container = inLayoutContainer;

          pThis.editorList[i].holder.insertAdjacentHTML('afterbegin', '<input type="hidden" name="sysEditor_EditAreaBegin_' + i + '">');
          pThis.editorList[i].holder.insertAdjacentHTML('beforeend', '<input type="hidden" name="sysEditor_EditAreaEnd_' + i + '">');

          pThis.editorList[i].outerHolder.setAttribute('data-wamultieditorindex', i);
          BEditor.domHandlers.addHandler(pThis.editorList[i].outerHolder, 'click', setEditorFocus);

          pThis.editorsCounter++;
        }

        newStyles = $document.createElement('STYLE');
        newStyles.setAttribute('type', 'text/css');
        newStyles.innerHTML = '.editorHolderBorder_Normal { outline: 1px dashed #CCCCCC; }' +
                              '.editorHolderBorder_Normal:hover { outline: 2px solid #F16600; }' +
                              '.editorHolderBorder_Active { outline: 1px dashed #F16600; }';
        $document.querySelector('HEAD').appendChild(newStyles);

        initEmailTimeCounter(); //TODO:Dime TimeEmailCounter
      }
      else
      {
        pThis.multiEditorMode = false;

        if (pThis.singleEditor.editor)
        {
          pThis.singleEditor.editor.reInitEditor(pThis.singleEditor.id, idIn, idOut, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, autoFocus, minEditorHeight, idIn, mainClassForBodyStyles, extParameters);
          pThis.singleEditor.contentIFrameName = pThis.singleEditor.editor.editorContentIFrameName;
        }
        else
        {
          pThis.singleEditor.id = editorId + '__S';
          pThis.singleEditor.editor = new BEditor.Editor(pThis, pThis.singleEditor.id, idIn, idOut, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, autoFocus, minEditorHeight, idIn, mainClassForBodyStyles, extParameters);
          pThis.singleEditor.contentIFrameName = pThis.singleEditor.editor.editorContentIFrameName;
        }
      }

      if (button)
      {
        button.showHideFormattingDropdownOptionalItems(pThis.multiEditorMode);
      }

      initEditors();
      pThis.EditorCreated.fireHandlers();
    }
    else
    {
      setTimeout(createEditors, 100);
    }
  }


  function getOuterHolder (holder)
  {
    do
    {
      holder = holder.parentNode;
    }
    while (holder.nodeName !== 'TABLE');

    return holder;
  }


  function initEditors()
  {
    var i;
    var editorObject = (pThis.multiEditorMode) ? pThis.editorList[0].editor : pThis.singleEditor.editor;

    for (k in editorObject)
    {
      if (editorObject.hasOwnProperty(k) && typeof(editorObject[k]) === 'function')
      {
        pThis[k] = new Function('return BEditor.EditorsManager.pEditors[' + mainEditorIndex + '].editor.methodsSwitcher("' + k + '", arguments);');
      }
    }

    if (pThis.multiEditorMode)
    {
      for (i = 0; i < pThis.editorsCounter; i++)
      {
        pThis.editorList[i].editor.addHandler('focus', captureEditorFocus);
        pThis.editorList[i].editor.addHandler('blur', captureEditorBlur);

        pThis.editorList[i].editor.EditorStarted.addHandler(onEditorStarted);
        pThis.editorList[i].editor.EditorStopped.addHandler(onEditorStopped);
        pThis.editorList[i].editor.EditorResized.addHandler(onEditorResized);
        pThis.editorList[i].editor.EditorClicked.addHandler(onEditorClicked);
        pThis.editorList[i].editor.EditorBlured.addHandler(onEditorBlured);
        pThis.editorList[i].editor.EditorDataChanged.addHandler(onEditorDataChanged);
      }

      setHoldersBorders();
    }
    else
    {
      pThis.singleEditor.editor.addHandler('focus', captureEditorFocus);
      pThis.singleEditor.editor.addHandler('blur', captureEditorBlur);

      pThis.singleEditor.editor.EditorStarted.addHandler(onEditorStarted);
      pThis.singleEditor.editor.EditorStopped.addHandler(onEditorStopped);
      pThis.singleEditor.editor.EditorResized.addHandler(onEditorResized);
      pThis.singleEditor.editor.EditorClicked.addHandler(onEditorClicked);
      pThis.singleEditor.editor.EditorBlured.addHandler(onEditorBlured);
      pThis.singleEditor.editor.EditorDataChanged.addHandler(onEditorDataChanged);
    }

    checkEditorsStateTM = setTimeout(checkEditorsState, waitScore);
  }


  function onEditorStarted (sender, args)
  {
    var editorId = sender.getEditorId(),
        editorIFrame = sender.getEditorIFrame();

    if (pThis.multiEditorMode && editorId != null && editorIFrame != null)
    {
      pThis.editorHash[editorId].editorIFrame = editorIFrame;
    }

    pThis.EditorStarted.fireHandlers(args);
  }


  function onEditorStopped (sender, args)
  {
    pThis.EditorStopped.fireHandlers(args);
  }


  function onEditorResized (sender, args)
  {
    pThis.EditorResized.fireHandlers(args);
  }


  function onEditorClicked (sender, args)
  {
    pThis.EditorClicked.fireHandlers(args);
  }


  function onEditorBlured (sender, args)
  {
    pThis.EditorBlured.fireHandlers(args);
  }


  function onEditorDataChanged()
  {
    pThis.EditorDataChanged.fireHandlers();
  }


  function checkEditorsState ()
  {
    var i,
        isObjValid = 2,
        retIsObjValid = 0,
        isObjStay = true,
        retIsObjStay = false;

    if (checkEditorsStateTM) clearTimeout(checkEditorsStateTM);

    if (pThis.multiEditorMode)
    {
      for (i = pThis.editorsCounter; i--;)
      {
        retIsObjValid = pThis.editorList[i].editor.isObjValid || 0;

        if (retIsObjValid < isObjValid)
        {
          isObjValid = retIsObjValid;
        }

        retIsObjStay = pThis.editorList[i].editor.isObjStay;

        if (!retIsObjStay)
        {
          isObjStay = false;
        }
      }

      isObjValid = isObjValid || false;
    }
    else
    {
      isObjValid = pThis.singleEditor.editor.isObjValid;
      isObjStay = pThis.singleEditor.editor.isObjStay;
    }

    pThis.isObjValid = isObjValid;
    pThis.isObjStay = isObjStay;

    if (isObjValid !== 2)
    {
      checkEditorsStateTM = setTimeout(checkEditorsState, 73);
    }
    else if (BEditor.isAdminPanelWaiting)
    {
      BEditor.isAdminPanelWaiting = false;

      if (topWin.AdminPanel)
      {
        topWin.AdminPanel.hideContentPageShadingContainer();
        topWin.AdminPanel.enableButtons();
      }
    }
  }


  function editorShadingON ()
  {
    if (!isEditorShadingON)
    {
      isEditorShadingON = true;
      BEditor.EditorsManager.showPageShadingContainer(true, null, null, true);
      editorShadingOFF();
    }
  }


  function editorShadingOFF ()
  {
    if (pThis.isObjValid === 2 && !isMockShadingON)
    {
      isEditorShadingON = false;
      BEditor.EditorsManager.hidePageShadingContainer(true);
      pThis.EditorReady.fireHandlers();
    }
    else
    {
      setTimeout(editorShadingOFF, 100);
    }
  }


  function methodsSwitcher(methodName, methodArguments)
  {
    var i,
        ret,
        overRet,
        needCallBaseMethod = true;

    BEditor.EditorsManager.Sys.currentMethodArguments = methodArguments;

    if ((pThis.multiEditorMode || methodName == 'reInitEditor') && overMethods[methodName] && (typeof (overMethods[methodName])).toLowerCase() == 'function')
    {
      overRet = overMethods[methodName](methodArguments);
      needCallBaseMethod = overRet.needCallBaseMethod;
      ret = overRet.value;
    }

    if (needCallBaseMethod)
    {
      if (pThis.multiEditorMode)
      {
        for (i = 0; i < pThis.editorsCounter; i++)
        {
          ret = callBaseMethod(i, methodName, methodArguments);
        }
      }
      else
      {
        ret = callBaseMethod(0, methodName, methodArguments);
      }
    }

    return ret;
  }


  function callBaseMethod(editorIndex, methodName, methodArguments)
  {
    var str,
        func;

    str = 'return BEditor.EditorsManager.pEditors[' + mainEditorIndex + '].editor.';
    str += (pThis.multiEditorMode) ? 'editorList[' + editorIndex + ']' : 'singleEditor';
    str += '.editor["' + methodName + '"](';
    str += getArgumentsString(methodArguments);
    str += ');';

    func = new Function(str);
    return func();
  }


  function getArgumentsString(methodArguments)
  {
    var i,
        str = '';

    for (i = 0; i < methodArguments.length; i++)
    {
      str += 'BEditor.EditorsManager.Sys.currentMethodArguments[' + i + ']' + ((i < methodArguments.length - 1) ? ',' : '');
    }

    return str;
  }


  function captureEditorFocus(firedEditorId, firedEditor, firedEvent)
  {
    var argsToSend,
        isFiredEditorCurrent = (currentFocusedEditor.editorId === firedEditorId);

    if (currentFocusedEditor.editorId != null && !isFiredEditorCurrent)
    {
      previousFocusedEditor.editorId = currentFocusedEditor.editorId;
      previousFocusedEditor.editor = currentFocusedEditor.editor;

      if (!isHolderFocusFrozen && pThis.editorHash[previousFocusedEditor.editorId])
      {
        setHolderBorder(pThis.editorHash[previousFocusedEditor.editorId].outerHolder, false);
      }
    }
    else if (!isHolderFocusFrozen)
    {
      setHoldersBorders();
    }

    currentFocusedEditor.editorId = firedEditorId;
    currentFocusedEditor.editor = firedEditor;

    if (!BEditor.browser.isIE) //TODO Dime Test EDGE !!!
    {
      if (isChangeEditorInstance && previousFocusedEditor && previousFocusedEditor.editor)
      {
        previousFocusedEditor.editor.clearSelection();
      }
      else
      {
        clearBlurredSelection();
      }
    }

    if (pThis.editorHash[currentFocusedEditor.editorId])
    {
      setHolderBorder(pThis.editorHash[currentFocusedEditor.editorId].outerHolder, true);
    }

    argsToSend = (pThis.editorHash[firedEditorId] ? { holderName: pThis.editorHash[firedEditorId].holderName } : { });

    if (!isFiredEditorCurrent)
    {
      pThis.EditorFocus.fireHandlers(argsToSend);
    }
  }


  function captureEditorBlur(firedEditorId, firedEditor, firedEvent)
  {
    if (currentFocusedEditor.editorId != null)
    {
      previousFocusedEditor.editorId = currentFocusedEditor.editorId;
      previousFocusedEditor.editor = currentFocusedEditor.editor;

      if (pThis.editorHash[previousFocusedEditor.editorId])
      {
        setHolderBorder(pThis.editorHash[previousFocusedEditor.editorId].outerHolder, false);
      }
    }
    else
    {
      setHoldersBorders();
    }

    currentFocusedEditor.editorId = null;
    currentFocusedEditor.editor = null;

    isChangeEditorInstance = true;
    if (changeEditorInstanceTM) clearTimeout(changeEditorInstanceTM);
    changeEditorInstanceTM = setTimeout(function () { isChangeEditorInstance = false; }, 50);

    pThis.EditorBlur.fireHandlers({ holderName: (pThis.editorHash[firedEditorId] ? pThis.editorHash[firedEditorId].holderName : null) });
  }


  function freezeHolderFocus ()
  {
    isHolderFocusFrozen = true;

    if (pThis.editorHash[currentFocusedEditor.editorId])
    {
      setHolderBorder(pThis.editorHash[currentFocusedEditor.editorId].outerHolder, true);
    }
    else if (pThis.editorHash[previousFocusedEditor.editorId])
    {
      setHolderBorder(pThis.editorHash[previousFocusedEditor.editorId].outerHolder, true);
    }
  }


  function unfreezeHolderFocus ()
  {
    isHolderFocusFrozen = false;
    setHoldersBorders();
  }


  function setEditorFocus (e = window.event)
  {
    if (!e) { return true; }

    let outerHolder,
        outerHolderCoords,
        editorIndex;

    e.isEditorFocused = true;
    outerHolder = e.currentTarget;

    if (outerHolder)
    {
      editorIndex = outerHolder.getAttribute('data-wamultieditorindex');

      if (editorIndex != null && editorIndex !== '')
      {
        editorIndex = parseInt(editorIndex);

        if (!isNaN(editorIndex) && pThis.editorList[editorIndex] && pThis.editorList[editorIndex].editor && pThis.editorList[editorIndex].editor.isObjValid === 2)
        {
          outerHolderCoords = BEditor.dimensions.getElementXY(outerHolder);
          pThis.editorList[editorIndex].editor.focus(true, ((e.clientY < outerHolderCoords.top + outerHolderCoords.height / 2) ? 1 : 2));
        }
      }
    }
  }


  function setHoldersBorders ()
  {
    var i;

    for (i = 0; i < pThis.editorsCounter; i++)
    {
      setHolderBorder(pThis.editorList[i].outerHolder, false);
    }
  }


  function setHolderBorder (outerHolder, state)
  {
    var className,
        stateName = (state) ? 'Active' : 'Normal';

    className = outerHolder.className;
    className = className.replace(/editorHolderBorder_(?:Normal|Hover|Active)/ig, '').replace(/\s+/g, ' ').replace(/(?:^\s+|\s+$)/g, '');
    outerHolder.className = className + ((className != null && className !== '') ? ' ' : '') + 'editorHolderBorder_' + stateName;
  }


  function setParentHolderSize ()
  {
    var pageLayoutMainContainerOffsetWidth = pageLayoutMainContainer.offsetWidth;

    if (parentContainer && parentContainer.style && pageLayoutMainContainer && pageLayoutMainContainerOffsetWidth != null)
    {
      parentContainer.style.paddingTop = '1px';
      parentContainer.style.paddingBottom = '1px';
      parentContainer.style.overflowX = 'auto';
    }
  }


  function changePageLayout (newLayoutHTML)
  {
    var i, k,
        aMatch,
        isNewMultiLayout,
        editableAreas,
        inLayoutContainer,
        addedContent = '',
        singleContent,
        singleContentTitle,
        editorInstanceContent,
        moduleCounter,
        currentContentHash = {},
        currentContentHashPointers = [],
        isContentChanged = false;

    if (pThis.isObjValid != 2 || (!pThis.multiEditorMode && newLayoutHTML.indexOf('data-cellinner') === -1))
    {
      if (BEditor.isAdminPanelWaiting)
      {
        BEditor.isAdminPanelWaiting = false;

        if (topWin.BEditor.AdminPanel)
        {
          topWin.AdminPanel.enableButtons();
        }
      }

      return false;
    }

    newLayoutHTML = newLayoutHTML.replace(/<!--WALayoutContent_.+?-->/g, '');
    isNewMultiLayout = (newLayoutHTML.indexOf('data-cellinner') !== -1);

    getChangeLayoutTimeCounter(isNewMultiLayout);  //TODO:Dime TimeEmailCounter

    if (pThis.multiEditorMode)
    {
      moduleCounter = 0;

      for (i = 0; i < pThis.editorsCounter; i++)
      {
        if (pThis.editorList[i].editor.getIsContentChanged())
        {
          isContentChanged = true;
        }

        editorInstanceContent = pThis.editorList[i].editor.getData(true).htmlContent;

        if (editorInstanceContent === null)
        {
          editorInstanceContent = '';
        }
        else if (editorInstanceContent !== '')
        {
          editorInstanceContent = editorInstanceContent.replace(/<\/?form(?:\s[^>]*>|>)/ig, '');
          editorInstanceContent = editorInstanceContent.replace(/(<div\s+[^>]*id=['"]?sysArtBoxModuleContainer\_)\d+(["']?(?:\s|>))/ig, function (bigStr, beginStr, endStr)
          {
            moduleCounter++;
            return beginStr + (moduleCounter - 1) + endStr;
          });
        }

        currentContentHash[pThis.editorList[i].holderName] = editorInstanceContent;
        currentContentHashPointers[i] = pThis.editorList[i].holderName;
      }

      if (!contentHash || isContentChanged)
      {
        contentHash = currentContentHash;
        contentHashPointers = currentContentHashPointers;
      }
    }
    else
    {
      if (!contentHash || pThis.singleEditor.editor.getIsContentChanged())
      {
        contentHash = null;
        singleContent = pThis.singleEditor.editor.getData().htmlContent;

        if (singleContent)
        {
          singleContent = singleContent.replace(/<\/?form(?:\s[^>]*>|>)/ig, '');
          aMatch = singleContent.match(/^(?:[\n\r\s]|&nbsp;)*(<h1(?:[\n\r\s][^>]*>|>)(?:.|[\n\s])*?<\/h1[\n\r\s]*>|<img[\n\r\s][^>]*src=['"]?[^'"\s]*\/content\/arttext\/\d+\/\d+\/\d+(?:-\d+)?\.png[^>]*>)/i);

          if (aMatch && aMatch.length > 1)
          {
            singleContentTitle = (aMatch[1]) ? aMatch[1] : null;
            aMatch = singleContent.match(/^(?:[\n\r\s]|&nbsp;)*(?:<h1(?:[\n\r\s][^>]*>|>)(?:.|[\n\s])*?<\/h1[\n\r\s]*>|<img[\n\r\s][^>]*src=['"]?[^'"\s]*\/content\/arttext\/\d+\/\d+\/\d+(?:-\d+)?\.png[^>]*>)((?:.|[\n\s])*)$/i);

            if (aMatch && aMatch.length > 1)
            {
              singleContent = (aMatch[1]) ? aMatch[1] : null;
            }
          }
          else
          {
            singleContentTitle = null;
          }
        }
        else
        {
          singleContent = null;
          singleContentTitle = null;
        }
      }
    }

    unloadEditor(true);

    inContainer = $(idIn);
    inContainer.innerHTML = newLayoutHTML;

    if (isNewMultiLayout)
    {
      if (pThis.multiEditorMode || contentHash)
      {
        for (k in contentHash)
        {
          if (contentHash.hasOwnProperty(k))
          {
            inLayoutContainer = inContainer.querySelector('[data-innereditablearea="' + k + '"]');

            if (inLayoutContainer)
            {
              inLayoutContainer.innerHTML = contentHash[k];
            }
            else
            {
              addedContent += contentHash[k].replace(/^(?:\s|&nbsp;)*<p(?:>|\s[^>]*>)\s*(?:<br(?:>|\s[^>]*>)|&nbsp;)?\s*<\/p>(?:\s|&nbsp;)*$/i, '');
            }
          }
        }

        if (addedContent !== '')
        {
          inLayoutContainer = inContainer.querySelector('[data-excesscontent]');

          if (!inLayoutContainer)
          {
            editableAreas = inContainer.querySelectorAll('[data-innereditablearea]');
            inLayoutContainer = editableAreas[editableAreas.length - 1];
          }

          inLayoutContainer.innerHTML += addedContent;
        }
      }
      else
      {
        if (singleContentTitle != null)
        {
          inLayoutContainer = inContainer.querySelector('[data-innereditablearea="headerEditableArea"]');

          if (inLayoutContainer)
          {
            inLayoutContainer.innerHTML = singleContentTitle;
          }
          else
          {
            singleContent = singleContentTitle + singleContent;
          }
        }

        if (singleContent != null)
        {
          inLayoutContainer = inContainer.querySelector('[data-maincontent]') || inContainer.querySelector('[data-excesscontent]') || inContainer.querySelector('[data-innereditablearea]');
          inLayoutContainer.innerHTML = singleContent;
        }
      }
    }
    else
    {
      if (pThis.multiEditorMode || contentHash)
      {
        for (i = 0; i < contentHashPointers.length; i++)
        {
          addedContent += contentHash[contentHashPointers[i]].replace(/^(?:\s|&nbsp;)*<p(?:>|\s[^>]*>)\s*(?:<br(?:>|\s[^>]*>)|&nbsp;)?\s*<\/p>(?:\s|&nbsp;)*$/i, '');
        }

        inContainer.innerHTML = addedContent;
      }
      else if (singleContent != null)
      {
        inContainer.innerHTML = singleContent;
      }
    }

    reInitEditor([undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false]);
    initAllEditors();
  }


  function changeTypography (className)
  {
    var i,
        contentStyles,
        button = pToolbar.getButtonByName('FormattingDropdownEmail');

    typographyCSSClasses = className;
    contentStyles = getContentStyles();

    button.setFormattingDropdownItemsClass(contentStyles.cssClasses);
    setEditorsCSSClasses();
  }


  function changeStyle (newStyles)
  {
    contentStyles = newStyles;

    if (contentStyles)
    {
      changeStyleDo(contentStyles);
    }
    else
    {
      restoreStyle();
    }
  }


  function changeStyleDo (styles)
  {
    var i,
        parameters,
        button,
        buttonsNames = ['ForeColorEmail', 'BackColorEmail'];

    styleCSSClasses = contentStyles.id;

    for (i = 0; i < buttonsNames.length; i++)
    {
      button = pToolbar.getButtonByName(buttonsNames[i]);
      parameters = button.getAttribute('parameters');
      parameters.themeColors = styles.colors;
      button.setAttribute('parameters', parameters);
      button.setColorDropdownThemeColors();
    }

    setEditorsCSSClasses();
  }


  function restoreStyle ()
  {
    var parameters,
        button = pToolbar.getButtonByName('ForeColor');

    parameters = button.getAttribute('parameters');

    contentStyles =
    {
      id: '',
      colors: parameters.themeColors,
      linkStyles: ''
    };

    changeStyleDo(contentStyles);
  }


  function setEditorsCSSClasses ()
  {
    var i;

    for (i = 0; i < pThis.editorsCounter; i++)
    {
      pThis.editorList[i].editor.changeBodyCSSClasses();
    }
  }


  function getContentStyles ()
  {
    return(
    {
      id: contentStyles.id,
      cssClasses: typographyCSSClasses + ((typographyCSSClasses !== '' && styleCSSClasses !== '') ? ' ' : '') + styleCSSClasses,
      linkStyles: contentStyles.linkStyles
    });
  }


  function clearBlurredSelection ()
  {
    var i;

    for (i = 0; i < pThis.editorsCounter; i++)
    {
      if (pThis.editorList[i].editorId !== currentFocusedEditor.editorId)
      {
        pThis.editorList[i].editor.clearSelection();
      }
    }
  }


  function reInitEditorStart (newArguments)
  {
    contentHash = null;
    contentHashPointers = null;

    return reInitEditor(newArguments);
  }


  function reInitEditor (newArguments)
  {
    var i;

    pThis.isObjExist = true;
    pThis.isObjValid = false;
    pThis.isObjStay = false;

    inContainer =  null;

    if (newArguments)
    {
      editorId = (newArguments[0] !== undefined) ? newArguments[0] : editorId;
      idIn = (newArguments[1] !== undefined) ? newArguments[1] : idIn;
      idOut = (newArguments[2] !== undefined) ? newArguments[2] : idOut;
      blankPageURL = (newArguments[3] !== undefined) ? newArguments[3] : blankPageURL;
      displayMode = (newArguments[4] !== undefined) ? newArguments[4] : displayMode;
      pToolbar = (newArguments[5] !== undefined) ? newArguments[5] : pToolbar;
      pToolbarConfig = (newArguments[6] !== undefined) ? newArguments[6] : pToolbarConfig;
      autoStart = (newArguments[7] !== undefined) ? newArguments[7] : autoStart;
      autoFocus = (newArguments[8] !== undefined) ? newArguments[8] : autoFocus;
      minEditorHeight = (newArguments[9] !== undefined) ? newArguments[9] : minEditorHeight;
      mainIdForBodyStyles = (newArguments[10] !== undefined) ? newArguments[10] : mainIdForBodyStyles;
      mainClassForBodyStyles = (newArguments[11] !== undefined) ? newArguments[11] : mainClassForBodyStyles;
      extParameters = (newArguments[12] !== undefined) ? newArguments[12] : extParameters;
    }

    for (i = 0; i < pThis.editorList.length; i++)
    {
      pThis.editorList[i].editorIFrame = null;
    }

    targetWindow = extParameters.targetWindow || topWin.contentarea || window;

    initEnvironment();
    initMultiEditor();

    if (pThis.multiEditorMode)
    {
      setHoldersBorders();
    }

    return { value: null, needCallBaseMethod: false };
  }


  function initAllEditors ()
  {
    var i;

    if (pThis.multiEditorMode)
    {
      for (i = 0; i < pThis.editorsCounter; i++)
      {
        pThis.editorList[i].editor.initEditor();
      }
    }
    else
    {
      pThis.singleEditor.editor.initEditor();
    }
  }


  function restoreAttributeForDragDrop ()
  {
    var i;

    for (i = 0; i < pThis.editorsCounter; i++)
    {
      pThis.editorList[i].editor.restoreAttributeForDragDropDo();
    }
  }


  function mouseMultiDragDrop ()
  {
    var i;

    if (pThis.multiEditorMode)
    {
      for (i = 0; i < pThis.editorsCounter; i++)
      {
        pThis.editorList[i].editor.mouseDragDrop();
      }
    }
    else
    {
      pThis.singleEditor.editor.mouseDragDrop();
    }
  }


  function getMultiAnchorsList ()
  {
    var i;
    var anchorsList = [];

    if (pThis.multiEditorMode)
    {
      for (i = 0; i < pThis.editorsCounter; i++)
      {
        anchorsList = anchorsList.concat(pThis.editorList[i].editor.getAnchorsList());
      }
    }
    else
    {
      anchorsList = anchorsList.concat(pThis.singleEditor.editor.getAnchorsList());
    }

    return anchorsList;
  }


  function setMultiAnchorsVisibility (state)
  {
    var i;

    if (pThis.multiEditorMode)
    {
      for (i = 0; i < pThis.editorsCounter; i++)
      {
        pThis.editorList[i].editor.setAnchorsVisibility(state);
      }
    }
    else
    {
      pThis.singleEditor.editor.setAnchorsVisibility(state);
    }
  }


  function getData ()
  {
    var i,
        holderName,
        editableContainer,
        htmlContent,
        outValues = [],
        layoutContainer = inContainer.querySelector('[data-layoutid]');

    if (layoutContainer)
    {
      for (i = 0; i < pThis.editorsCounter; i++)
      {
        holderName = pThis.editorList[i].holderName;
        outValues[holderName] = pThis.editorList[i].editor.getData(false, { isFixBigImageWidth: true, isDeleteLayoutMarkup: true }).htmlContent;

        if (outValues[holderName] === null)
        {
          outValues[holderName] = '';
        }

        if (pThis.editorList[i].hideWhenEmpty)
        {
          if (!(outValues[holderName].match(/<(?:img|image|iframe|object|embed|a[^>]+name\s*=[^>]+)(?:[\s\n\r]|[\/>])/i) ||
              outValues[holderName].match(/&nbsp;(?:.|[\n\r])*&nbsp;/i) ||
              outValues[holderName].replace(/(?:<[^>]*>|&nbsp;|[\s\n\r]+)/ig, '') != ''))
          {
            if (outValues[holderName].indexOf('sysEditor_SafeSaveContentBegin') != -1 && outValues[i].indexOf('sysEditor_SafeSaveContentEnd') != -1)
            {
              outValues[holderName] = '<input name="sysEditor_SafeSaveContentBegin" type="hidden"><input name="sysEditor_SafeSaveContentEnd" type="hidden">';
            }
            else
            {
              outValues[holderName] = '';
            }
          }
        }
      }

      htmlContainer.innerHTML = inContainer.innerHTML;
      removeSysAttributes(htmlContainer);

      setEmailTimeCounter(htmlContainer); //TODO:Dime TimeEmailCounter

      for (k in outValues)
      {
        if (outValues.hasOwnProperty(k))
        {
          editableContainer = htmlContainer.querySelector('[data-innereditablearea="' + k + '"]');
          editableContainer.style.display = '';
          editableContainer.innerHTML = outValues[k];
          editableContainer.parentNode.innerHTML = editableContainer.outerHTML;
        }
      }

      htmlContent = htmlContainer.innerHTML;
      htmlContainer.innerHTML = '';
    }
    else
    {
      htmlContent = inContainer.innerHTML;

      if (htmlContent.match(/##WA###BlankHTMLPageForEditorContentNew###WA##/))
      {
        htmlContent = pThis.editorList[0].editor.restoreLinksToAnchors(htmlContent);
      }
    }

    var domains = BEditor.environment.getAdditionalDomainNames();
    htmlContent = BEditor.urlConverter.convertUrls(htmlContent, domains);

    return { value: htmlContent, needCallBaseMethod: false };
  }


  function setData (htmlContent)
  {
    unloadEditor(true);

    inContainer = $(idIn);
    inContainer.innerHTML = htmlContent;

    reInitEditor([undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false]);
    initAllEditors();
  }


  function getTextData ()
  {
    var i,
        str = '';

    for (i = 0; i < pThis.editorsCounter; i++)
    {
      str += pThis.editorList[i].editor.getTextData();
    }

    return { value: str, needCallBaseMethod: false };
  }


  function getHtmlDataLength ()
  {
    var str = pThis.getData();

    return { value: str.length, needCallBaseMethod: false };
  }


  function saveData ()
  {
    var htmlContent;

    if ($(idOut))
    {
      htmlContent = pThis.getData();

      if (!isTrueEmail && htmlContent != null)
      {
        htmlContent = emailEditorMock.inlineStyles(htmlContent);
      }

      $(idOut).value = htmlContent;
    }

    return { value: null, needCallBaseMethod: false };
  }


  function removeSysAttributes (container)
  {
    var i, n,
        elements,
        rules =
        [
          {
            rule: '[data-wamultieditorindex]',
            attr: 'data-wamultieditorindex'
          },
          {
            rule: '[class*="editorHolderBorder_"]',
            func: function (element)
            {
              var className = element.className;

              className = className.replace(/editorHolderBorder_(?:Normal|Hover|Active)/ig, '').replace(/\s+/g, ' ').replace(/(?:^\s+|\s+$)/g, '');

              if (className === '')
              {
                element.removeAttribute('class');
              }
              else
              {
                element.className = className;
              }
            }
          }
        ];

    for (i = 0; i < rules.length; i++)
    {
      elements = container.querySelectorAll(rules[i].rule);

      for (n = 0; n < elements.length; n++)
      {
        if (rules[i].func)
        {
          rules[i].func(elements[n]);
        }
        else
        {
          elements[n].removeAttribute(rules[i].attr);
        }
      }
    }
  }


  function initEmailTimeCounter ()
  { //TODO:Dime TimeEmailCounter
    var timeCounter,
        element = inContainer.querySelector('[data-waedittimecounter]');

    if (element)
    {
      timeCounter = element.getAttribute('data-waedittimecounter');
      editTimeCounter = ((timeCounter && !isNaN(parseInt(timeCounter))) ? parseInt(timeCounter) : 0);
      element.removeAttribute('data-waedittimecounter');
    }
    else
    {
      editTimeCounter = 0;
    }

    editTimeCounter += changeLayoutTimeCounter;
    changeLayoutTimeCounter = 0;

    if (pThis.multiEditorMode)
    {
      startEmailTimeCounter();
    }
  }


  function getChangeLayoutTimeCounter (isNewMultiLayout)
  { //TODO:Dime TimeEmailCounter
    var element,
        timeCounter;

    stopEmailTimeCounter();
    changeLayoutTimeCounter = 0;

    if (isNewMultiLayout)
    {
      element = (pThis.multiEditorMode ? inContainer.querySelector('[data-waedittimecounter]') : pThis.singleEditor.editor.getEditorIFrame().document.body.querySelector('[data-waedittimecounter]'));

      if (element)
      {
        timeCounter = element.getAttribute('data-waedittimecounter');
        changeLayoutTimeCounter = ((timeCounter && !isNaN(parseInt(timeCounter))) ? parseInt(timeCounter) : 0);
        element.removeAttribute('data-waedittimecounter');
      }

      }
  }


  function startEmailTimeCounter ()
  { //TODO:Dime TimeEmailCounter
    editTimeStart = (new Date()).getTime();
    isStartEmailTimeCounter = true;
    checkChangeContentForEmailTimeCounter(true);
  }


  function stopEmailTimeCounter ()
  { //TODO:Dime TimeEmailCounter
    changeEmailTimeCounter();
    isStartEmailTimeCounter = false;
    if (checkChangeContentForEmailTimeCounterTM) clearTimeout(checkChangeContentForEmailTimeCounterTM);
  }


  function changeEmailTimeCounter ()
  { //TODO:Dime TimeEmailCounter
    editTimeStop = (new Date()).getTime();
    editTimeCounter += editTimeStop - editTimeStart;
    editTimeStart = editTimeStop;
    }


  function setEmailTimeCounter (container)
  { //TODO:Dime TimeEmailCounter
    var element = container.querySelector('[data-layoutid]') || container.firstElementChild;

    if (element)
    {
      if (editTimeStart !== 0)
      {
        changeEmailTimeCounter();
      }

      element.setAttribute('data-waedittimecounter', editTimeCounter.toString());
      }
  }


  function checkChangeContentForEmailTimeCounter (isInit)
  { //TODO:Dime TimeEmailCounter
    var i,
        currentContent;

    if (checkChangeContentForEmailTimeCounterTM) clearTimeout(checkChangeContentForEmailTimeCounterTM);

    changeEmailTimeCounter();

    currentContent = pageLayoutMainContainer.outerHTML;

    for (i = 0; i < pThis.editorsCounter; i++)
    {
      currentContent += (pThis.editorList[i].editorIFrame ? pThis.editorList[i].editorIFrame.document.body.outerHTML : '');
    }

    if (saveContentForEmailTimeCounter === currentContent && !isInit)
    {
      editTimeCounter -= editTimeCounterInterval;

      if (editTimeCounter < 0)
      {
        editTimeCounter = 0;
      }

      }
    else
    {
      saveContentForEmailTimeCounter = currentContent;
    }

    checkChangeContentForEmailTimeCounterTM = setTimeout(checkChangeContentForEmailTimeCounter, editTimeCounterInterval);
    }


  function getEditTimeCounter ()
  {
    return editTimeCounter;
  }


  function unloadedEditor (editor)
  {
    var i;

    pThis.isObjExist = editor.isObjExist;
    pThis.isObjValid = editor.isObjValid;
    pThis.isObjStay = editor.isObjStay;

    if (pThis.multiEditorMode)
    {
      for (i = pThis.editorsCounter; i--;)
      {
        if (pThis.editorList[i].editor.isObjExist)
        {
          pThis.isObjExist = true;
          break;
        }
      }

      for (i = pThis.editorsCounter; i--;)
      {
        if (pThis.editorList[i].editor.isObjValid === 2)
        {
          pThis.isObjValid = 2;
          break;
        }
      }

      for (i = pThis.editorsCounter; i--;)
      {
        if (pThis.editorList[i].editor.isObjStay)
        {
          pThis.isObjStay = true;
          break;
        }
      }
    }
  }


  function unloadEditor(isLocalUnload)
  {
    var i,
        skipEditorId = null;

    if (checkEditorsStateTM) clearTimeout(checkEditorsStateTM);
    if (checkChangeContentForEmailTimeCounterTM) clearTimeout(checkChangeContentForEmailTimeCounterTM); //TODO:Dime TimeEmailCounter

    pThis.isObjExist = false;
    pThis.isObjValid = false;
    pThis.isObjStay = false;

    if (pThis.multiEditorMode)
    {
      if (currentFocusedEditor.editorId && currentFocusedEditor.editor)
      {
        skipEditorId = currentFocusedEditor.editorId;
        currentFocusedEditor.editor.unload();
        currentFocusedEditor.editor.isObjValid = false;
        currentFocusedEditor.editor.isObjStay = false;
      }
      else if (previousFocusedEditor.editorId && previousFocusedEditor.editor)
      {
        skipEditorId = previousFocusedEditor.editorId;
        previousFocusedEditor.editor.unload();
        previousFocusedEditor.editor.isObjValid = false;
        previousFocusedEditor.editor.isObjStay = false;
      }

      for (i = 0; i < pThis.editorsCounter; i++)
      {
        if (!(skipEditorId && pThis.editorList[i].id == skipEditorId))
        {
          pThis.editorList[i].editor.unload();
          pThis.editorList[i].editor.isObjValid = false;
          pThis.editorList[i].editor.isObjStay = false;
        }
      }
    }
    else
    {
      pThis.singleEditor.editor.unload();
      pThis.singleEditor.editor.deleteEditor();
      pThis.singleEditor.editor.isObjValid = false;
      pThis.singleEditor.editor.isObjStay = false;
    }

    if (isLocalUnload !== true)
    {
      contentHash = null;
      contentHashPointers = null;
    }

    return false;
  }

}